
  const Documents='https://api-bms.shiraz.ir/swagger-ui.html&output=embed'


// const ServerIP="https://bms.shiraz.ir/SessionManager/api?Q="
// const MapUrl="https://map.shiraz.ir/srvtiles/{z}/{x}/{y}"
// const Captcha='https://bms.shiraz.ir/SessionManager/images'


//  const Name='سازمان مدیریت حمل و نقل مسافر شهرداری شیراز'
// const ServerIP="https://api-bms.shiraz.ir/api/v2?Q="
// const UsersLogin="https://api-bms.shiraz.ir/Users/Login"
// const MapUrl="https://map.shiraz.ir/srvtiles/{z}/{x}/{y}"
// const Captcha='https://api-bms.shiraz.ir/images'
// const Session='https://api-bms.shiraz.ir/Session/Check'


const ServerIP="https://api.tfms.ir/api/v2?Q="
const UsersLogin="https://api.tfms.ir/Users/Login"
const MapUrl="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
const Captcha='https://api.tfms.ir/images'
const Session='https://api.tfms.ir/Session/Check'
const Name='اتحادیه حمل و نقل مسافر شهری کشور'
//const Name='سازمان مدیریت حمل و نقل مسافر شهرداری اندیشه'
//const Name='سازمان مدیریت حمل و نقل مسافر شهرداری قائن'

 

const PayServerIP="https://api.tfms.ir/api/pay/"
const Contant = {
    Name:Name,
    Session:Session,
    MapUrl:MapUrl,
    Captcha:Captcha,
    Documents:Documents,
    Fleet_GetAll:ServerIP+"Fleet_GetAll",
    User_AddFull:ServerIP+"User_AddFull",
    FleetByUser:ServerIP+"FleetByUser&UserID=2188",
    Fleet_GetLikeName:ServerIP+"Fleet_GetLikeName&UserID=2188&Key={Key}",
    Device_GetInfoLikeIMEI:ServerIP+"Device_GetInfoLikeIMEI&UserID=2188&Key={Key}",
    Fleet_GetAccessByGroup:ServerIP+"Fleet_GetAccessByGroup&GroupID={GroupID}",
    DeviceByFleet:ServerIP+"Device_GetByFleetID&FleetID={FleetID}",
    Device_GetByFleetID_SortMaxEN:ServerIP+"Device_GetByFleetID_SortMaxEN&FleetID={FleetID}",
    Device_GetByVehicle:ServerIP+"Device_GetByVehicle&UserID={DeviceID}&VehicleID={VehicleID}",
    Vehicle_GetByFleetID:ServerIP+"Vehicle_GetByFleetID&FleetID={FleetID}",
    Driver_GetByFleetID:ServerIP+"Driver_GetByFleetID&FleetID={FleetID}",
    Device_GetAllByUserID:ServerIP+"Device_GetAllByUserID&UserID={UserID}",
    Device_GetLikeIMEI:ServerIP+"Device_GetLikeIMEI&Key={Key}&Type={Type}&Assign={Assign}",
    UsersLogin:UsersLogin,
    Permission:ServerIP+"RulesPermission_GetByUserID&UserID=0",
    MapObject_GetPointsMarker:ServerIP+"MapObject_GetPointsMarker&FleetID={FleetID}",
    MapObject_GetByFleetAndType:ServerIP+"MapObject_GetByFleetAndType&FleetID={FleetID}&Type={Type}",
    MapObject_GetMarkerByFleet:ServerIP+"MapObject_GetMarkerByFleet&FleetID={FleetID}",
    MapPoints_GetByID:ServerIP+"MapPoints_GetByID&ObjectID={ObjectID}",
    GPSData:ServerIP+"GPSData_GetByDeviceID&DeviceID={DeviceID}&TS1={TS1}&TS2={TS2}",
    Report_Vehicle_Park:ServerIP+"Report_Vehicle_Park&VehicleID={VehicleID}&StartTime={StartTime}&EndTime={EndTime}",
    Report_Vehicle_Stop:ServerIP+"Report_Vehicle_Stop&VehicleID={VehicleID}&StartTime={StartTime}&EndTime={EndTime}&StopThreshold=5",
    Report_X1ByFleet:ServerIP+"Report_X1ByFleet&FleetID={FleetID}&TS1_={TS1}&TS2_={TS2}",
    Report_X1:ServerIP+"Report_X1&VehicleID={VehicleID}&TS1={TS1}&TS2={TS2}",
    DeviceType_GetAll:ServerIP+"DeviceType_GetAll",
    UserGroup_GetAll:ServerIP+"UserGroup_GetAll",
    Device_AssignToFleet:ServerIP+"Device_AssignToFleet",
    Device_Update:ServerIP+"Device_Update",
    Device_MoveToFleet:ServerIP+"Device_MoveToFleet",
    VehicleType_GetAll:ServerIP+"VehicleType_GetAll",
    Vehicle_Update:ServerIP+"Vehicle_Update",
    Personnel_GetByID:ServerIP+"Personnel_GetByID&PersonelID={PersonelID}",
    Driver_Update:ServerIP+"Driver_Update",
    User_GetAll:ServerIP+"User_GetAll",
    User_Update:ServerIP+"User_Update",
    User_GetByGroupID:ServerIP+"User_GetAllByGroupID&GroupID={GroupID}",
    User_ChangePass:ServerIP+"User_ChangePass",
    Alarm_GetAdvance:ServerIP+"Alarm_GetAdvance&UserID={UserID}&PageNumber={PageNumber}&RowsOfPage={RowsOfPage}&AlarmID={AlarmID}&FleetID={FleetID}&TS1={TS1}&TS2={TS2}",
    Alarm_GetAdvanceReport:ServerIP+"Alarm_GetAdvance&UserID={UserID}&PageNumber={PageNumber}&RowsOfPage={RowsOfPage}&AlarmID={AlarmID}&FleetID={FleetID}&TS1={TS1}&TS2={TS2}",
    Fleet_Add:ServerIP+"Fleet_Add",
    Fleet_Update:ServerIP+"Fleet_Update",
    ConnectionState_GetToday:ServerIP+"ConnectionState_GetToday&UserID={UserID}",
    ConnectionState_Get:ServerIP+"ConnectionState_GetByUserAndDate$@UserID=1$@TS1=2022_02_03t00_00_00",
    ConnectionState_GetMonth:ServerIP+"ConnectionState_GetMonth&UserID={UserID}",
    BusLine_GetByUserID:ServerIP+"BusLine_GetByUserID&UserID={UserID}",
    LineStations_GetByUserID:ServerIP+"LineStations_GetByUserID&UserID={UserID}&FleetID={FleetID}",
    Trajectory_GetByUserID:ServerIP+"Trajectory_GetByUserID&UserID={UserID}&FleetID={FleetID}",
    SendMessage:ServerIP+"Messages_AddAuto",
    User_GetAllDeviceStatus:ServerIP+"User_GetAllDeviceStatus&UserID={UserID}",
    Device_GetAllStatusByUserID2:ServerIP+"Device_GetAllStatusByUserID2&UserID={UserID}",
    BusLines_GetInfo:ServerIP+"BusLines_GetInfo&UserID={UserID}",
    DeviceDistanceHistory_GetByUserGroupByDay:ServerIP+"DeviceDistanceHistory_GetByUserGroupByDay&UserID={UserID}",
    Authentication_Add:ServerIP+"Authentication_Add",
    Authentication_Delete:ServerIP+"Authentication_Delete&UserID={UserID}&FleetID={FleetID}",
    AlarmDefinitions_GetAll:ServerIP+"AlarmDefinitions_GetAll",
    DayDefine_GetAll:ServerIP+"DayDefine_GetAll",
    DayDefine_Insert:ServerIP+"DayDefine_Insert",
    DayDefine_Update:ServerIP+"DayDefine_Update",
    DayDefine_DeletByID:ServerIP+"DayDefine_DeletByID&DayDefineID={DayDefineID}",
    SmartTariff_GetAll:ServerIP+"SmartTariff_GetAll&UserID={UserID}",
    SmartTariff_GetByFleetID:ServerIP+"SmartTariff_GetByFleetID&FleetID={FleetID}&UserID={UserID}",
    SmartTariff_InsertAndUpdate:ServerIP+"SmartTariff_InsertAndUpdate",
    SmartTariff_Delete:ServerIP+"SmartTariff_Delete&FleetID={FleetID}&DayDefineID={DayDefineID}",
    Device_UpdateMaxEN:ServerIP+"Device_UpdateMaxEN",
    SmartTariff_GetToDay:ServerIP+"SmartTariff_GetToDay&FleetID={FleetID}&DayDefineID={DayDefineID}",
    Calendar_InsertAndUpdate:ServerIP+"Calendar_InsertAndUpdate",
    Calendar_GetByDate:ServerIP+"Calendar_GetByDate&UserID={UserID}&TS1={TS1}&TS2={TS2}",
    TrajectoryHistory_GetByUserAndTime:ServerIP+"TrajectoryHistory_GetByUserAndTime&UserID={UserID}&TS1={TS1}&TS2={TS2}",
    TrajectoryHistory_GetByFleetAndTime:ServerIP+"TrajectoryHistory_GetByFleetAndTime&FleetID={FleetID}&TS1={TS1}&TS2={TS2}",
    TrajectoryHistory_GetByDeviceIDAndTime:ServerIP+"TrajectoryHistory_GetByDeviceIDAndTime&DeviceID={DeviceID}&TS1={TS1}&TS2={TS2}",
    Trajectory_FleetMustChange:ServerIP+"Trajectory_FleetMustChange&UserID={UserID}",
    Trajectory_FleetMustChangeALL:ServerIP+"Trajectory_FleetMustChangeALL&UserID={UserID}",
    Commands_Add:ServerIP+"Commands_Add",
    FleetHistory_GetByDate:ServerIP+"FleetHistory_GetByDate&TS1={TS1}&TS2={TS2}",
    FleetHistory_GetByDriver:ServerIP+"FleetHistory_GetByDriver&TS1={TS1}&TS2={TS2}&DriverID={DriverID}",
    FleetHistory_GetByFleet:ServerIP+"FleetHistory_GetByFleet&TS1={TS1}&TS2={TS2}&FleetID={FleetID}",
    FleetHistory_GetByVehicle:ServerIP+"FleetHistory_GetByVehicle&TS1={TS1}&TS2={TS2}&VehicleID={VehicleID}",
    DeviceDistanceHistory_GetALLDayByDevice:ServerIP+"DeviceDistanceHistory_GetALLDayByDevice&TS1={TS1}&TS2={TS2}&DeviceID={DeviceID}",
    DeviceDistanceHistory_GetByUserIDAndDate:ServerIP+"DeviceDistanceHistory_GetByUserIDAndDate&TS1={TS1}&TS2={TS2}&UserID={UserID}",
    DeviceDistanceHistory_GetByFleetAndDate:ServerIP+"DeviceDistanceHistory_GetByFleetAndDate&TS1={TS1}&TS2={TS2}&UserID={UserID}&FleetID={FleetID}",
    StationTraffic_GetByStasionCodeAndTime:ServerIP+"StationTraffic_GetByStasionCodeAndTime&TS1={TS1}&TS2={TS2}&UserID={UserID}&StationCode={StationCode}",
    StationTraffic_GetByDeviceAndTime:ServerIP+"StationTraffic_GetByDeviceAndTime&TS1={TS1}&TS2={TS2}&UserID={UserID}&DeviceID={DeviceID}",
    Station_GetByFleet2:ServerIP+"Station_GetByFleet2&FleetID={FleetID}",
    Fleet_GetComplateData:ServerIP+"Fleet_GetComplateData&UserID={UserID}",
    Company_GetByUserID:ServerIP+"Company_GetByUserID&UserID={UserID}",
    Company_Insert:ServerIP+"Company_Insert",
    Company_UpdateByID:ServerIP+"Company_UpdateByID",
    ViolationList_GetAll:ServerIP+"ViolationList_GetAll",
    ViolationList_Insert:ServerIP+"ViolationList_Insert",
    Violation_GetAdvance:ServerIP+"Violation_GetAdvance&UserID={UserID}&FleetID={FleetID}&DeviceID={DeviceID}&TS1={TS1}&TS2={TS2}&type={type}",
    Violation_GetTop10ByUserID:ServerIP+"Violation_GetTop10ByUserID&UserID={UserID}",
    Violation_Insert:ServerIP+"Violation_Insert",
    BusLines_GetByCrop:ServerIP+"BusLines_GetByCrop&UserID={UserID}&Lat1={Lat1}&Lat2={Lat2}&Lng1={Lng1}&Lng2={Lng2}",
    Station_GetByCrop:ServerIP+"Station_GetByCrop&UserID={UserID}&Lat1={Lat1}&Lat2={Lat2}&Lng1={Lng1}&Lng2={Lng2}",
    Device_GetByCrop:ServerIP+"Device_GetByCrop&UserID={UserID}&Lat1={Lat1}&Lat2={Lat2}&Lng1={Lng1}&Lng2={Lng2}",
    Violation_Delete:ServerIP+"Violation_Delete&UserID={UserID}&ViolationID={ViolationID}&ViolationTS={ViolationTS}&DeviceID={DeviceID}",
    ViolationList_Delete:ServerIP+"ViolationList_Delete&UserID={UserID}&ViolationID={ViolationID}",
    SystemInfo_Get:ServerIP+"SystemInfo_Get",
    DeviceSipad_GetDetaileByUser:ServerIP+"DeviceSipad_GetDetaileByUser&UserID={UserID}&TS1={TS1}&TS2={TS2}",
    DeviceSipad_GetByFleet:ServerIP+"DeviceSipad_GetByFleet&UserID={UserID}&FleetID={FleetID}&TS1={TS1}&TS2={TS2}",
    DeviceSipad_GetByDevice:ServerIP+"DeviceSipad_GetByDevice&DeviceID={DeviceID}&TS1={TS1}&TS2={TS2}",
    Rules_GetAll:ServerIP+"Rules_GetAll",
    Rules_Get:ServerIP+"Rules_Get&Roles_ID={Roles_ID}",
    RulesPermission_Update:ServerIP+"RulesPermission_Update",
    RulesApiPermissions_GetByRole:ServerIP+"RulesApiPermissions_GetByRole&RoleID={RoleID}",
    RulesApiPermissions_InsertOrUpdate:ServerIP+"RulesApiPermissions_InsertOrUpdate",
    Rules_Insert:ServerIP+"Rules_Insert",
    User_Delete:ServerIP+"User_Delete&UserID={UserID}&UserIDTarget={UserIDTarget}",
    ViolationList_Update:ServerIP+"ViolationList_Update",
    Violation_Update:ServerIP+"Violation_Update",
    SipadErrorLog_GetByTurn:ServerIP+"SipadErrorLog_GetByTurn&UserID={UserID}&TS1={TS1}&TS2={TS2}&TS3={TS3}",
    DeviceSipad_GetStatus:ServerIP+"DeviceSipad_GetStatus&UserID={UserID}&TS1={TS1}&TS2={TS2}&TS3={TS3}",
    UserGroup_DeleteByID:ServerIP+"UserGroup_DeleteByID&UserID={UserID}&GroupID={GroupID}",
    User_ChangeRole:ServerIP+"User_ChangeRole",
    Device_AdvancedSearch:ServerIP+"Device_AdvancedSearch",
    Vehicle_AdvancedSearch:ServerIP+"Vehicle_AdvancedSearch",
    Driver_AdvancedSearch:ServerIP+"Driver_AdvancedSearch",
    User_ActiveList:ServerIP+"User_ActiveList&UserID={UserID}&Count={Count}",
    Fleet_GetAllActiveInfo:ServerIP+"Fleet_GetAllActiveInfo&UserID={UserID}",
    Widget1_Get:ServerIP+"Widget1_Get",
    Widget2_Get:ServerIP+"Widget2_Get",
    Widget3_Get:ServerIP+"Widget3_Get",
    Widget4_Get:ServerIP+"Widget4_Get",
    Widget5_Get:ServerIP+"Widget5_Get",


    //pay
    TransactionFilter:PayServerIP+"switch/card-financial/filter?page={page}&size={size}",
    Transaction:PayServerIP+"transactions?page=$page&size=$size",
    TransactionSearch:PayServerIP+"transactions?page=$page&size=$size&search=",
    TransactionLogSearch:PayServerIP+"batch-transaction-logs?page=$page&size=$size&search=",
    TransactionLog:PayServerIP+"batch-transaction-logs?page=$page&size=$size",
    Merchant:PayServerIP+"merchants?page=$page&size=$size",
    AddMerchant:PayServerIP+"merchants",
    Person:PayServerIP+"persons?page=0&size=100",
    MerchantType:PayServerIP+"definitions/merchant-types",
    TransactionLogSearchByDate:"http://85.15.46.129:8000/bfl",
    TransactionLogSearchByDateAndFleet:"http://85.15.46.129:8000/fleet_report",
};
export default Contant